export const useStyle = () => {
  return {
    avatar: (isLoaded = false) => ({
      transition: 'opacity 0.3s ease',
      opacity: isLoaded ? 1 : 0,
      borderRadius: '100%',
    }),
  };
};
